<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Nombre interno <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="name" placeholder="Ej: demo"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            [class.border-error-500]="hasError('name')"
            [class.border-gray-300]="!hasError('name')" />
          @if (hasError('name')) {
            <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p>
          }
        </div>
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Etiqueta <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="label" placeholder="Ej: Demo de producto"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            [class.border-error-500]="hasError('label')"
            [class.border-gray-300]="!hasError('label')" />
          @if (hasError('label')) {
            <p class="mt-1.5 text-sm text-error-500">{{ getError('label') }}</p>
          }
        </div>
      </div>

      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Descripción</label>
        <textarea formControlName="description" rows="2" placeholder="Descripción del tipo (opcional)"
          class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"></textarea>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Color</label>
          <input type="color" formControlName="color"
            class="h-11 w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 cursor-pointer" />
        </div>
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Duración (min)</label>
          <input type="number" formControlName="defaultDurationMinutes" placeholder="30"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
        </div>
      </div>

      <!-- INC 33 — selector visual de íconos -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Ícono</label>
        <input type="hidden" formControlName="icon" />
        <div class="flex flex-wrap gap-2">
          @for (opt of iconOptions; track opt.key) {
            <button
              type="button"
              (click)="selectIcon(opt.key)"
              [title]="opt.label"
              [attr.aria-pressed]="isIconSelected(opt.key)"
              class="flex h-11 w-11 items-center justify-center rounded-lg border transition-colors focus:outline-hidden focus:ring-3 focus:ring-brand-500/10"
              [class.border-brand-500]="isIconSelected(opt.key)"
              [class.bg-brand-50]="isIconSelected(opt.key)"
              [class.text-brand-600]="isIconSelected(opt.key)"
              [class.dark:bg-brand-500/10]="isIconSelected(opt.key)"
              [class.dark:border-brand-500]="isIconSelected(opt.key)"
              [class.dark:text-brand-400]="isIconSelected(opt.key)"
              [class.border-gray-300]="!isIconSelected(opt.key)"
              [class.text-gray-500]="!isIconSelected(opt.key)"
              [class.dark:border-gray-700]="!isIconSelected(opt.key)"
              [class.dark:text-gray-400]="!isIconSelected(opt.key)"
              [class.hover:border-brand-300]="!isIconSelected(opt.key)">
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                @for (d of opt.paths; track d) {
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" [attr.d]="d" />
                }
              </svg>
            </button>
          }
        </div>
        <p class="mt-1.5 text-xs text-gray-400 dark:text-gray-500">Opcional. Pulsa un ícono para seleccionarlo o quitarlo.</p>
      </div>

      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Orden</label>
        <input type="number" formControlName="sortOrder"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
      </div>

      <div class="flex items-center gap-3">
        <input id="requiresLocation" type="checkbox" formControlName="requiresLocation"
          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500" />
        <label for="requiresLocation" class="text-sm text-gray-700 dark:text-gray-300">Requiere ubicación</label>
      </div>

      <div class="flex items-center gap-3">
        <input id="requiresUrl" type="checkbox" formControlName="requiresUrl"
          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500" />
        <label for="requiresUrl" class="text-sm text-gray-700 dark:text-gray-300">Requiere URL de videollamada</label>
      </div>

      <div class="flex items-center gap-3">
        <input id="typeIsActive" type="checkbox" formControlName="isActive"
          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500" />
        <label for="typeIsActive" class="text-sm text-gray-700 dark:text-gray-300">Activo</label>
      </div>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>

    <!-- ===== Franjas horarias permitidas (INC 35) ===== -->
    <div class="mt-6 pt-5 border-t border-gray-200 dark:border-gray-700">
      <h4 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
        Franjas horarias permitidas
      </h4>
      @if (isEditing && typeId) {
        <app-meeting-type-availability [typeId]="typeId" />
      } @else {
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Guarda primero el tipo de reunión para configurar sus franjas horarias permitidas.
        </p>
      }
    </div>
  }
</div>
